import { useState } from "react";
export function useDismissedNotificationIds() {
    const [dismissedNotificationIds, setDismissedNotificationIds] = useState([]);
    return {
        dismissedNotificationIds,
        setDismissedNotificationIds,
    };
}
